import React from 'react';

const Hero = () => {
  return (
    <section className="relative pt-24 pb-20 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1542157565-4607d82cf417?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxwZWFjZWZ1bCUyMG5hdHVyZXxlbnwwfHx8fDE3NzE3MzA0OTZ8MA&ixlib=rb-4.1.0&q=85"
          alt="Peaceful nature background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/60 via-blue-800/50 to-white"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Understanding the Journey Through Grief
          </h1>
          <p className="text-xl text-blue-50 mb-8 leading-relaxed">
            Grief is a natural response to loss. Learning about the stages can help you navigate 
            this difficult journey with compassion and understanding.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a 
              href="#stages"
              className="px-8 py-3 bg-white text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              Explore the Stages
            </a>
            <a 
              href="#resources"
              className="px-8 py-3 bg-transparent border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-all duration-200"
            >
              Find Resources
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
